/**
 * New typescript file
 */
import { Panel } from './panel.model';
export class PwrCnt {
  pwr: number; // moc zestwu paneli
  cnt: number; // liczba paneli w zestawie
  panel: Panel; // model paneli w zestawie
}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/model/pwrcnt.model.ts